
import { Component, Vue } from 'vue-property-decorator';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
const { VUE_APP_FCAPI: FCAPI, VUE_APP_STAGE: STAGE } = process.env;
import { namespace } from 'vuex-class';
import { follow_status } from '../../../module/select';

const Hundun = namespace('Hundun');
const API = {
  get_list: `${FCAPI}/boss/hundun/setting/tag`
};
@Component
export default class TagManage extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.Action('FETCH_TAGS') getTags: any; //获取tag
  /* eslint-enable */
  type = 1;
  is_ai = false;
  tags_list: any = {};
  tags_chuang_list: any = {};
  show_fail_delete = false; //标签删除失败弹框
  modal_title = '';
  label_title = '';
  seconds: any = [[], [], []];
  first: any = [];
  customStyle = 'background-color:#fff;border:0;';
  locale = zhCN;
  form: any;
  show_modal = false;
  isloading = false;
  is_edit = false;
  level = 0; // 新增级别
  parent_id = 0; // 新增父id
  delete_id = 0;
  edit_id = 0;
  fail_reason = '';
  table_data: any = {
    //表格数据
  };
  sort_index: any = '';
  parent_options: any = [];
  parent_values: any = [];
  fuzzy_keyword: any = '';
  fuzzy_keywords: any = [];
  exact_keywords: any = [];
  follow_status = follow_status.slice(1).map((item: any) => ({
    value: item.id,
    label: item.value
  }));

  //新增标签
  addTag(index: number, record?: any, item?: any) {
    this.is_ai = false;
    this.is_edit = false;
    this.parent_values = [];
    this.modal_title = index === 1 ? '新增标签' : index === 2 ? '新增二级标签' : '新增三级标签';
    this.label_title = index === 1 ? '一级标签' : index === 2 ? '二级标签' : '三级标签';
    this.show_modal = true;
    if (item) {
      this.parent_id = item.id;
      this.level = 3;
    } else if (!item && record) {
      this.parent_id = record.id;
      this.level = 2;
    } else if (!item && !record) {
      this.parent_id = 0;
      this.level = 1;
    }

    if (record) {
      this.parent_values.push(record.id);
    }

    if (item) {
      this.parent_values.push(item.id);
    }

    console.debug(this.parent_values);

    setTimeout(() => {
      this.form.setFieldsValue({
        sort: 0,
        match_count: 1,
        follow_statuses: [],
        match_sources: ['1', '2', '3', '4'],
        update_frequency: 1,
      });
    });
  }
  //编辑
  edit(index: number, record?: any, item?: any, item2?: any) {
    this.is_edit = true;
    this.parent_values = [];
    const tag_name = index === 1 ? record.tag_name : index === 2 ? item.tag_name : item2.tag_name;
    const sort = index === 1 ? record.sort : index === 2 ? item.sort : item2.sort;
    this.edit_id = index === 1 ? record.id : index === 2 ? item.id : item2.id;
    this.modal_title = index === 1 ? '编辑标签' : index === 2 ? '编辑二级标签' : '编辑三级标签';
    this.label_title = index === 1 ? '一级标签名称' : index === 2 ? '二级标签名称' : '三级标签名称';

    if (item2) {
      this.parent_values.push(record.id);
      this.parent_values.push(item.id);
    } else if (item) {
      this.parent_values.push(record.id);
    }

    console.log(this.parent_values);

    this.show_modal = true;

    const data = index === 1 ? record : index === 2 ? item : item2;
    this.is_ai = data.is_ai;
    this.fuzzy_keywords = data.fuzzy_keywords;
    this.exact_keywords = data.exact_keywords;

    console.info(index, record, item, item2, sort);
    setTimeout(() => {
      this.form.setFieldsValue({
        tag_name,
        sort,
        match_sources: data.match_sources,
        follow_statuses: data.follow_statuses,
        match_count: data.match_count,
        update_frequency: data.update_frequency
      });
    });
  }

  handleParentChange(parent_values: any) {
    console.info('handleParentChange:', parent_values);
    this.parent_values = parent_values;
  }

  //删除
  async deleteTag(id: number) {
    const res: any = await this.$axios.delete(`${API.get_list}/${id}`);
    if (res.data.status === 200) {
      this.$message.success('删除成功');
      this.getTags();
      this.getTagList(this.tags_list.current);
    } else {
      this.fail_reason = res.data.message;
      this.show_fail_delete = true;
    }
  }

  errorMessage = (res: any) => {
    if (res.status !== 410) {
      return true;
    } else {
      return false;
    }
  };

  async handleSortInput(item: any) {
    const res = await this.$axios.put(`${API.get_list}/${item.id}`, {
      id: item.id,
      sort: item.sort,
      kind: 'sort'
    });

    const remote = res.data;
    if (res.status !== 200) {
      if (this.errorMessage(res)) {
        this.$message.error(remote.message);
      }
      return;
    }

    this.sort_index = '';
    await this.getTagList(this.tags_list.current);
  }

  handleSortEdit(index: any) {
    this.sort_index = index;
  }

  //提交新增、编辑标签
  submit() {
    this.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        if (!this.is_edit) {
          //新增
          const send_data = {
            parent_id: this.parent_id,
            tag_name: values.tag_name,
            sort: values.sort,
            level: this.level,
            type: this.type,
            is_ai: this.is_ai,
            fuzzy_keywords: this.fuzzy_keywords,
            exact_keywords: this.exact_keywords,
            match_sources: values.match_sources,
            follow_statuses: values.follow_statuses,
            match_count: values.match_count,
            update_frequency: values.update_frequency
          };
          console.info('create_send_data:', send_data);
          const res: any = await this.$axios.post(API.get_list, send_data);
          if (res.data.status === 200) {
            this.getTagList(this.tags_list.current);
            this.cancel();
            this.form.resetFields();
          } else {
            this.$message.error(res.data.message);
          }
          this.getTags();
          console.log(res);
        } else {
          // 编辑
          const level = this.parent_values.length + 1;
          const parent_id = this.parent_values.pop();
          if (parent_id == this.edit_id) {
            this.$message.error('不能将自己设置为上级目录');
            return null;
          }

          const { tag_name, sort } = values;
          const send_data = {
            parent_id,
            tag_name,
            sort,
            level,
            is_ai: this.is_ai,
            fuzzy_keywords: this.fuzzy_keywords,
            exact_keywords: this.exact_keywords,
            match_sources: values.match_sources,
            follow_statuses: values.follow_statuses,
            match_count: values.match_count,
            update_frequency: values.update_frequency
          };

          console.info('edit_send_data:', send_data);
          const res: any = await this.$axios.put(`${API.get_list}/${this.edit_id}`, send_data);
          if (res.status === 200) {
            this.$message.success('编辑成功');
            this.cancel();
            this.getTags();
            this.getTagList(this.tags_list.current);
          }
        }
        console.log('Received values of form: ', values);
      }
    });
  }
  //关闭折叠栏,将打开的二级也一起关闭
  closeCollapse(record: any, index: number) {
    console.log(this.first[index]);
    if (this.first[index].length === 0) {
      const id_list = record.parent.map((item: any) => '' + item.id);
      console.log(id_list);
      for (let i = 0; i < this.seconds.length; i++) {
        for (let j = 0; j < this.seconds[i].length; j++) {
          if (id_list.indexOf(this.seconds[i][j]) !== -1) {
            this.seconds[i].splice(j, 1);
            j--;
          }
        }
      }
      this.seconds[index] = [];
    }
  }
  changePanel(value: any, index: number) {
    console.log(value, index);
    this.seconds[index] = value;
  }
  changePage(data: any) {
    this.getTagList(data.current);
  }
  paginationOption(data: any) {
    return {
      current: +data.current || 0,
      total: data.total || 0,
      pageSize: data.limit || 0,
      showTotal: () => `共${data.total}条，每页${data.limit}条`
    };
  }
  cancel() {
    this.form.resetFields();
    this.show_modal = false;
  }
  async getTagList(current = 1) {
    this.isloading = true;
    const res: any = await this.$axios(API.get_list, {
      params: { current: current, page: 10, type: this.type }
    });

    console.info(res.status, STAGE);
    if (res.status === 200) {
      if (this.type == 1) this.tags_list = res.data.data ? res.data.data : [];
      else this.tags_chuang_list = res.data.data ? res.data.data : [];
    }

    const res_options: any = await this.$axios(API.get_list, {
      params: { kind: 'cascader', type: this.type }
    });

    if (res_options.status === 200) {
      this.parent_options = res_options.data.data ? res_options.data.data : [];
    }

    this.isloading = false;
  }
  tabsChange() {
    this.getTagList();
  }
  created() {
    this.getTagList(1);
  }
  //form实例初始化必须这么写(antd和ts的原因)
  beforeCreate() {
    this.form = this.$form.createForm(this);
  }
  addFuzzyKeyword() {
    const fuzzy_keyword = this.form.getFieldValue('fuzzy_keyword');
    const fuzzy_keyword_trim = fuzzy_keyword.trim();
    if (fuzzy_keyword_trim) {
      if (this.fuzzy_keywords.includes(fuzzy_keyword_trim)) {
        this.$message.error('关键词已存在');
        return;
      }
      this.fuzzy_keywords.push(fuzzy_keyword_trim);
      this.form.setFieldsValue({
        fuzzy_keyword: ''
      });
    }
  }
  removeFuzzyKeyword(index: number) {
    this.fuzzy_keywords.splice(index, 1);
  }
  addExactKeyword() {
    const exact_keyword = this.form.getFieldValue('exact_keyword');
    const exact_keyword_trim = exact_keyword.trim();
    if (exact_keyword_trim) {
      if (this.exact_keywords.includes(exact_keyword_trim)) {
        this.$message.error('关键词已存在');
        return;
      }
      this.exact_keywords.push(exact_keyword_trim);
      this.form.setFieldsValue({
        exact_keyword: ''
      });
    }
  }
  removeExactKeyword(index: number) {
    this.exact_keywords.splice(index, 1);
  }
}
